import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CardDsfrContext from "components/CardDsfrContext";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import NewsTabs from "components/templates/news/NewsTabs";
import CardContext from "components/templatesComponents/CardContext";
import LastNewsBlock from "components/templatesComponents/LastNewsBlock";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import t from "utils/locales/translation.json";

const LastNewsTemplate = (props) => {
  const { page: pageVersion } = props;
  const { title, contents, page, shortDescription, template } = pageVersion;
  const { highlightedNews, oldCardsNews = {}, homeButton = {} } = contents;
  const { lang } = page;

  const { props: oldCardsNewsProps = {} } = oldCardsNews;
  const { cards: haveCards, children: isOnBackOffice } = oldCardsNewsProps;

  const { props: homeButtonProps = {} } = homeButton;
  const { children: homeButtonChildren, page: homeButtonPage, url: homeButtonUrl } = homeButtonProps;
  const buttonOnBackOffice = typeof homeButtonChildren === "object";

  const displaySubtitle = haveCards || isOnBackOffice || buttonOnBackOffice || homeButtonPage || homeButtonUrl;

  const displayCards = haveCards || isOnBackOffice;

  const displayButton = buttonOnBackOffice || (!haveCards && (homeButtonPage || homeButtonUrl));

  const cardHighlightedContextValue = useMemo(() => ({ isHorizontal: true, showImage: true }), []);
  const cardContextValue = useMemo(
    () => ({
      Wrapper: Grid,
      wrapperProps: {
        size: { xs: 12, md: 6 },
      },
    }),
    [],
  );

  const bo = useMemo(() => typeof title === "object", [title]);

  return (
    <>
      <TemplateBanner bo={bo} template={template}>
        <Stack>
          <h1>{title}</h1>
          {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        </Stack>
      </TemplateBanner>
      <CardDsfrContext.Provider value={cardHighlightedContextValue}>
        <Wrapper template={template} sx={{ px: { xs: 2, lg: 0 } }}>
          <NewsTabs currentPageVersion={pageVersion} />
          <LastNewsBlock highlightedNews={highlightedNews} lang={lang} />
          {displaySubtitle && (
            <Box component="p" className="fr-text--xl fr-text--bold" sx={{ mt: 5 }}>
              {t[lang].last_news.tile_cards_title}
            </Box>
          )}
          {displayCards && (
            <Grid container spacing={2}>
              <CardContext.Provider value={cardContextValue}>{oldCardsNews}</CardContext.Provider>
            </Grid>
          )}
          {displayButton && (
            <Grid container spacing={2} sx={{ alignItems: "center" }}>
              <button type="button" className="fr-btn fr-btn--tertiary">
                {homeButton}
              </button>
              {buttonOnBackOffice && <i>(Bouton également utilisé sur la page d&apos;Accueil)</i>}
            </Grid>
          )}
        </Wrapper>
        <HelpAndShare
          alwaysDisplayShare
          template={template}
          mt={displayButton ? 5 : 8}
          wrapperProps={{ breakpoint: "xl" }}
        />
      </CardDsfrContext.Provider>
    </>
  );
};

LastNewsTemplate.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.node,
    shortDescription: PropTypes.node,
    contents: PropTypes.shape(),
    page: PropTypes.shape(),
    template: PropTypes.string,
  }).isRequired,
};

export default LastNewsTemplate;
